<template>
    <div class="modal fade" id="costumModalperubahan" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">Perubahan OWP & AWP</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 75vh; height: 75vh;">
                    <p>
                    <div class="row">
                        <div class="col-sm-12">
                            <label>OWP (Rp.)</label>
                            <div class="input-group mb-3">
                                <input type="text" class="form-control form-control-sm" id="OWPlokal" name="OWPlokal"
                                    placeholder="OWP" v-model="OWPLokal" @keyup="formattulisrupiah('OWPlokal')"
                                        @keydown="formattulisrupiah('OWPlokal')">
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label class="text-success">AWP</label>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="col-sm-6 float-left" v-for="(datadata, urutdata) in AWP" :key="urutdata">
                                <label>AWP {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'AWPLokal' + datadata.Tahun" :name="'AWPLokal' + datadata.Tahun"
                                        placeholder="AWP" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('AWPLokal' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('AWPLokal' + datadata.Tahun)">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label class="text-success">DIPA</label>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="col-sm-6 float-left" v-for="(datadata, urutdata) in DIPA" :key="urutdata">
                                <label>DIPA {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'DIPALokal' + datadata.Tahun" :name="'DIPALokal' + datadata.Tahun"
                                        placeholder="DIPA" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('DIPALokal' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('DIPALokal' + datadata.Tahun)" 
                                </div>
                            </div>
                        </div>
                    </div>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-success btn-sm lebar2 text-white" @click="simpanajuan()"> <i
                            class="fas fa-angle-double-up"></i>
                        Ajukan</button>
                    <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                            class="far fa-times-circle"></i>
                        Tutup</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <div class="modal fade" id="costumModalsinkronisasi" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="margin: auto;">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Sinkronisasi Data Emon</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify">
                    <p>
                    <div class="row">
                        <div class="col-sm-6">
                            <label>OWP (Rp.)</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="radioOWP" checked
                                            @click="rubahowp('OWPlokal')">
                                    </div>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="OWPlokal" name="OWPlokal"
                                    placeholder="OWP" v-model="OWP" disabled>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label>OWP Emon (Rp.)</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="radioOWP"
                                            @click="rubahowp('OWPEmon')">
                                    </div>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="OWPEmon" name="OWPEmon"
                                    placeholder="OWP" v-model="OWPEmon" disabled>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label class="text-success">AWP</label>
                        </div>
                        <div class="col-sm-6 float-left">
                            <div class="col-sm-12 float-left" v-for="(datadata, urutdata) in AWP" :key="urutdata">
                                <label>AWP {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio"
                                                :name="'radioAWP' + datadata.Tahun" checked
                                                @click="rubahsinkronisasi('AWPLokal' + datadata.Tahun, 'AWP' + datadata.Tahun)">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'AWPLokal' + datadata.Tahun" :name="'AWPLokal' + datadata.Tahun"
                                        placeholder="AWP" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('AWPLokal' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('AWPLokal' + datadata.Tahun)" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <div class="col-sm-12 float-left" v-for="(datadata, urutdata) in AWPEmon" :key="urutdata">
                                <label>AWP Emon {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio"
                                                :name="'radioAWP' + datadata.Tahun"
                                                @click="rubahsinkronisasi('AWPEmon' + datadata.Tahun, 'AWP' + datadata.Tahun)">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'AWPEmon' + datadata.Tahun" :name="'AWPEmon' + datadata.Tahun"
                                        placeholder="AWP" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('AWPEmon' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('AWPEmon' + datadata.Tahun)" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label class="text-success">DIPA</label>
                        </div>
                        <div class="col-sm-6 float-left">
                            <div class="col-sm-12 float-left" v-for="(datadata, urutdata) in DIPA" :key="urutdata">
                                <label>DIPA {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio"
                                                :name="'radioDIPA' + datadata.Tahun" checked
                                                @click="rubahsinkronisasi('DIPALokal' + datadata.Tahun, 'DIPA' + datadata.Tahun)">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'DIPALokal' + datadata.Tahun" :name="'DIPALokal' + datadata.Tahun"
                                        placeholder="DIPA" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('DIPALokal' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('DIPALokal' + datadata.Tahun)" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <div class="col-sm-12 float-left" v-for="(datadata, urutdata) in DIPAEmon" :key="urutdata">
                                <label>DIPA {{ datadata.Tahun }} (Rp.)</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio"
                                                :name="'radioDIPA' + datadata.Tahun"
                                                @click="rubahsinkronisasi('DIPAEmon' + datadata.Tahun, 'DIPA' + datadata.Tahun)">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control form-control-sm"
                                        :id="'DIPAEmon' + datadata.Tahun" :name="'DIPAEmon' + datadata.Tahun"
                                        placeholder="DIPA" :value="G_numFormat(datadata.Nilai)"
                                        @keyup="formattulisrupiah('DIPAEmon' + datadata.Tahun)"
                                        @keydown="formattulisrupiah('DIPAEmon' + datadata.Tahun)" disabled>
                                </div>
                            </div>
                        </div>
                    </div>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                            class="far fa-times-circle"></i>
                        Tutup</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Monev">Monev Proyek</a></li>
                                <li class="breadcrumb-item active">Pengaturan Monev Proyek</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Monev Proyek</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="card card-primary collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #005c95 !important;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title text-white">1. INFORMASI PAKET PEKERJAAN</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-6 float-left">
                                                            <label>PIU <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="id_user" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedid_user"
                                                                @update:modelValue="onid_userChange"
                                                                :disabled="roleuser != 'admin'"
                                                                style="background-color: #ffffff;"></v-select>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Kode Register<small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="register"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedregister"
                                                                @update:modelValue="onregisterChange"
                                                                style="background-color: #ffffff;display: none;"></v-select>
                                                            <v-select multiple :options="register"
                                                                :disabled="roleuser != 'admin'"
                                                                :reduce="(label) => label.code" label="label"
                                                                @option:selected="onregisterChangeSelect($event)"
                                                                @option:deselected="onregisterChangeDeselect($event)"
                                                                v-model="arraynamaregister" id="registerku"
                                                                style="background-color: #ffffff;"></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-6 float-left" style="display: none;">
                                                            <label>Nama Kegiatan PMIS <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="idpmis" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedidpmis"
                                                                @update:modelValue="onidpmisChange"
                                                                style="background-color: #ffffff;"></v-select>
                                                        </div>
                                                        <div class="col-sm-12 float-left">
                                                            <label>Satker <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="satker" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedsatker"
                                                                @update:modelValue="onsatkerChange"
                                                                :disabled="roleuser != 'admin'"
                                                                style="background-color: #ffffff;"></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-12">
                                                            <label>Nama Kegiatan <small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Nama_Kegiatan" name="Nama_Kegiatan"
                                                                    :disabled="roleuser != 'admin'"
                                                                    placeholder="Nama Kegiatan" v-model="Nama_Kegiatan">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Lokasi Utama<small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="lokasi" :reduce="(label) => label.code"
                                                                label="label" v-model="defaultSelectedlokasi"
                                                                @update:modelValue="onlokasiChange"
                                                                :disabled="roleuser != 'admin'"
                                                                style="background-color: #ffffff;"></v-select>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Bank Review <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="bankreview"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedbankreview"
                                                                :disabled="roleuser != 'admin'"
                                                                @update:modelValue="onbankreviewChange"
                                                                style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                                        </div>
                                                        <div class="col-sm-12 float-left">
                                                            <label>Lokasi Kab./Kota Detail <small class="text-info">
                                                                    (*wajib dipilih)</small></label>
                                                            <v-select multiple :options="lokasi"
                                                                :reduce="(label) => label.code" label="label"
                                                                :disabled="roleuser != 'admin'"
                                                                @option:selected="onlokasiChangeSelect($event)"
                                                                @option:deselected="onlokasiChangeDeselect($event)"
                                                                v-model="arraynamalokasi" id="lokasiku"
                                                                style="background-color: #ffffff;"></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Komponen / Output<small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="Komponen"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedKomponen"
                                                                :disabled="roleuser != 'admin'"
                                                                @update:modelValue="onKomponenChange"
                                                                style="background-color: #ffffff;"></v-select>
                                                        </div>
                                                        <div class="col-sm-6 float-left">
                                                            <label>Sub Komponen<small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="SubKomponen"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedSubKomponen"
                                                                :disabled="roleuser != 'admin'"
                                                                @update:modelValue="onSubKomponenChange"
                                                                style="background-color: #ffffff;"></v-select>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-12 text-center" style="display: none;">
                                                            <button type="button"
                                                                class="btn btn-danger3 btn-sm text-white"
                                                                @click="sinkorinasi()"> <i
                                                                    class="fas fa-arrows-alt-h"></i>
                                                                Sinkronisasi / Ambil Data Emon</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="card card-primary collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #ffc107 !important;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title">2. TAHAPAN PENGADAAN</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-12 float-left">
                                                            <label>Jenis Pekerjaan <small class="text-info"> (*wajib
                                                                    dipilih)</small></label>
                                                            <v-select :options="jenispekerjaan"
                                                                :reduce="(label) => label.code" label="label"
                                                                v-model="defaultSelectedjenispekerjaan"
                                                                @update:modelValue="onjenispekerjaanChange"
                                                                style="background-color: #ffffff;"
                                                                :disabled="roleuser != 'admin'"></v-select>
                                                        </div>
                                                        <div class="col-sm-12 float-left">&nbsp;</div>
                                                        <div class="col-sm-12 float-left"
                                                            v-for="(datadata, urutdata) in tahapanpekerjaan"
                                                            :key="urutdata">
                                                            <label class="text-success"> {{ datadata.nama }}</label>
                                                            <div class="col-sm-12 float-left"
                                                                v-for="(datadatadetail, urutdatadetail) in datadata.tahapan"
                                                                :key="urutdatadetail">
                                                                <div class="row">
                                                                    <div class="col-sm-6">
                                                                        <label class="text-warning">Tahapan {{
                                                                            urutdatadetail + 1
                                                                            }}</label>
                                                                        <div class="custom-control custom-checkbox">
                                                                            <input
                                                                                class="custom-control-input custom-control-input-warning"
                                                                                type="checkbox"
                                                                                :checked="datadatadetail.pilihtahapan"
                                                                                :id="'Status_pekerjaan_' + datadatadetail.id"
                                                                                @click="cekvalidasitahapan(datadatadetail.id)">
                                                                            <label
                                                                                :for="'Status_pekerjaan_' + datadatadetail.id"
                                                                                class="custom-control-label">
                                                                                {{ datadatadetail.nama }}</label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-3">
                                                                        <label>Mulai</label>
                                                                        <div class="input-group mb-3">
                                                                            <div class="input-group-prepend">
                                                                                <span class="input-group-text"><i
                                                                                        class="fab fa-creative-commons-share"></i></span>
                                                                            </div>
                                                                            <input type="date"
                                                                                class="form-control form-control-sm"
                                                                                :id="'Mulai' + datadatadetail.id"
                                                                                :name="'Mulai' + datadatadetail.id"
                                                                                placeholder="Mulai"
                                                                                :value="datadatadetail.mulai">
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-3">
                                                                        <label>Selesai</label>
                                                                        <div class="input-group mb-3">
                                                                            <div class="input-group-prepend">
                                                                                <span class="input-group-text"><i
                                                                                        class="fab fa-creative-commons-share"></i></span>
                                                                            </div>
                                                                            <input type="date"
                                                                                class="form-control form-control-sm"
                                                                                :id="'Selesai' + datadatadetail.id"
                                                                                :name="'Selesai' + datadatadetail.id"
                                                                                placeholder="Selesai"
                                                                                :value="datadatadetail.selesai"
                                                                                @change="cektanggal(datadatadetail.id)">
                                                                        </div>
                                                                    </div>
                                                                    <!--IKON PETA 1-->
                                                                    <div class="col-sm-12">
                                                                        <label>File Pendukung<small class="text-info">
                                                                                (*pdf)</small>
                                                                        </label>
                                                                        <div class="input-group mb-3">
                                                                            <div class="input-group-prepend">
                                                                                <span class="input-group-text"><i
                                                                                        class="far fa-file-image"></i></span>
                                                                            </div>
                                                                            <input type="file"
                                                                                class="form-control form-control-sm"
                                                                                :id="'fileToUploadfilenya_tahapan' + datadatadetail.id"
                                                                                :name="'fileToUploadfilenya_tahapan' + datadatadetail.id"
                                                                                placeholder="fileToUpload"
                                                                                style="font-size: smaller;"
                                                                                accept="application/pdf">
                                                                            <input type="hidden"
                                                                                class="form-control form-control-sm"
                                                                                :id="'filenya_tahapan' + datadatadetail.id"
                                                                                :name="'filenya_tahapan' + datadatadetail.id"
                                                                                placeholder="File Pendukung">
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        <label>Opsi</label>
                                                                        <div class="row">
                                                                            <div class="col-sm-9">
                                                                                <div class="progress">
                                                                                    <div class="progress-bar"
                                                                                        role="progressbar"
                                                                                        aria-valuenow="0"
                                                                                        aria-valuemin="0"
                                                                                        aria-valuemax="100"
                                                                                        style="width:0%"
                                                                                        :id="'persennyafilenya_tahapan' + datadatadetail.id">
                                                                                        <span
                                                                                            :id="'tulisanpersenfilenya_tahapan' + datadatadetail.id">0%</span>
                                                                                    </div>
                                                                                </div>
                                                                                <br>
                                                                                <span class="text-success"
                                                                                    :id="'suksesnyafilenya_tahapan' + datadatadetail.id"></span>
                                                                            </div>
                                                                            <div class="col-sm-3 text-center">
                                                                                <button type="button"
                                                                                    class="btn btn-warning btn-sm lebar text-white"
                                                                                    @click="uploadfile('filenya_tahapan' + datadatadetail.id, 'application/pdf')">Upload
                                                                                    File</button>
                                                                                <button type="button"
                                                                                    class="btn btn-danger btn-sm lebar"
                                                                                    @click="clearfilepeta('filenya_tahapan' + datadatadetail.id)">Hapus
                                                                                    File</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!--IKON PETA 1 END-->

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="card card-pink collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #005c95 !important;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title text-white">3. DATA KONTRAK</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <label>Penyedia<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Penyedia" name="Penyedia"
                                                                    placeholder="Penyedia">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Nilai Kontrak (Rp.)<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Nilai" name="Nilai" placeholder="Nilai Kontrak"
                                                                    @keyup="formattulisrupiah('Nilai')"
                                                                    @keydown="formattulisrupiah('Nilai')">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Mulai Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="date" class="form-control form-control-sm"
                                                                    id="Mulai" name="Mulai" placeholder="Mulai Kontrak">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Selesai Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="date" class="form-control form-control-sm"
                                                                    id="Selesai" name="Selesai"
                                                                    placeholder="Selesai Kontrak">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Nomor Kontrak<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Kontrak" name="Kontrak"
                                                                    placeholder="Nomor Kontrak">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Adendum</label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Adendum" name="Adendum" placeholder="Adendum">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="card card-info collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #ffc107 !important;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title">4. OWP DAN AWP</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-12 text-center">
                                                            <button type="button"
                                                                class="btn btn-sm btn-success text-white"
                                                                @click="ajukanperubahan()" v-if="roleuser != 'admin'"
                                                                data-toggle="tooltip" data-placement="left"
                                                                title="Simpan data.."><i class="fas fa-plus-square"></i>
                                                                Ajukan Perubahan OWP, AWP dan DIPA</button>
                                                        </div>
                                                        <div class="col-sm-12 text-center">&nbsp;</div>
                                                        <div class="col-sm-12">
                                                            <label>OWP (Rp.)<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="OWP" name="OWP" placeholder="OWP" v-model="OWP"
                                                                    @keyup="formattulisrupiah('OWP')"
                                                                    :disabled="roleuser != 'admin'"
                                                                    @keydown="formattulisrupiah('OWP')">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left"
                                                            v-for="(datadata, urutdata) in AWP" :key="urutdata"
                                                            v-if="secretencData != 'Tambah'">
                                                            <label>AWP {{ datadata.Tahun }} (Rp.)<small
                                                                    class="text-info">
                                                                    (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    :id="'AWP' + datadata.Tahun"
                                                                    :name="'AWP' + datadata.Tahun" placeholder="AWP"
                                                                    :value="G_numFormat(datadata.Nilai)"
                                                                    :disabled="roleuser != 'admin'"
                                                                    @keyup="formattulisrupiah('AWP' + datadata.Tahun)"
                                                                    @keydown="formattulisrupiah('AWP' + datadata.Tahun)">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left"
                                                            v-for="(datadata, urutdata) in AWP" :key="urutdata"
                                                            v-if="secretencData == 'Tambah'">
                                                            <label>AWP {{ datadata.Tahun }} (Rp.)<small
                                                                    class="text-info">
                                                                    (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    :id="'AWP' + datadata.Tahun"
                                                                    :name="'AWP' + datadata.Tahun" placeholder="AWP"
                                                                    value="0" :disabled="roleuser != 'admin'"
                                                                    @keyup="formattulisrupiah('AWP' + datadata.Tahun)"
                                                                    @keydown="formattulisrupiah('AWP' + datadata.Tahun)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="card card-teal collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #005c95 !important;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title text-white">5. DIPA</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-6 float-left"
                                                            v-for="(datadata, urutdata) in DIPA" :key="urutdata"
                                                            v-if="secretencData != 'Tambah'">
                                                            <label>DIPA {{ datadata.Tahun }} (Rp.)<small
                                                                    class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    :id="'DIPA' + datadata.Tahun"
                                                                    :name="'DIPA' + datadata.Tahun" placeholder="DIPA"
                                                                    :value="G_numFormat(datadata.Nilai)"
                                                                    :disabled="roleuser != 'admin'"
                                                                    @keyup="formattulisrupiah('DIPA' + datadata.Tahun)"
                                                                    @keydown="formattulisrupiah('DIPA' + datadata.Tahun)">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left"
                                                            v-for="(datadata, urutdata) in DIPA" :key="urutdata"
                                                            v-if="secretencData == 'Tambah'">
                                                            <label>DIPA {{ datadata.Tahun }} (Rp.)<small
                                                                    class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    :id="'DIPA' + datadata.Tahun"
                                                                    :name="'DIPA' + datadata.Tahun" placeholder="DIPA"
                                                                    value="0"
                                                                    @keyup="formattulisrupiah('DIPA' + datadata.Tahun)"
                                                                    @keydown="formattulisrupiah('DIPA' + datadata.Tahun)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="card card-success collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #ffc107 !important;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title">6. REALISASI</h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-6 float-left"
                                                            v-for="(datadata, urutdata) in REALISASI" :key="urutdata"
                                                            v-if="secretencData != 'Tambah'">
                                                            <label>REALISASI {{ datadata.Tahun }} (Rp.)<small
                                                                    class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    :id="'REALISASI' + datadata.Tahun"
                                                                    :name="'REALISASI' + datadata.Tahun"
                                                                    placeholder="REALISASI"
                                                                    :value="G_numFormat(datadata.Nilai)"
                                                                    @keyup="formattulisrupiah('REALISASI' + datadata.Tahun)"
                                                                    @keydown="formattulisrupiah('REALISASI' + datadata.Tahun)">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 float-left"
                                                            v-for="(datadata, urutdata) in REALISASI" :key="urutdata"
                                                            v-if="secretencData == 'Tambah'">
                                                            <label>REALISASI {{ datadata.Tahun }} (Rp.)<small
                                                                    class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    :id="'REALISASI' + datadata.Tahun"
                                                                    :name="'REALISASI' + datadata.Tahun"
                                                                    placeholder="REALISASI" value="0"
                                                                    @keyup="formattulisrupiah('REALISASI' + datadata.Tahun)"
                                                                    @keydown="formattulisrupiah('REALISASI' + datadata.Tahun)">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Realisasi Kumulatif OCR-1NPBHBMA (Rp.)<small
                                                                    class="text-info">
                                                                    (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Realisasi" name="Realisasi"
                                                                    placeholder="Nilai Realisasi Kumulatif"
                                                                    @keyup="formattulisrupiah('Realisasi')"
                                                                    @keydown="formattulisrupiah('Realisasi')">
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-6">
                                                            <label>Realisasi Kumulatif UK-1LMM5M5A (Rp.)<small
                                                                    class="text-info">
                                                                    (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Realisasi2" name="Realisasi2"
                                                                    placeholder="Nilai Realisasi Kumulatif"
                                                                    @keyup="formattulisrupiah('Realisasi2')"
                                                                    @keydown="formattulisrupiah('Realisasi2')">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="card card-secondary collapsed-card">
                                                <div class="card-header border-transparent"
                                                    style="cursor: pointer;background-color: #005c95 !important;"
                                                    data-card-widget="collapse">
                                                    <h3 class="card-title text-white">7. TARGET, CAPAIAN DAN ISIAN LAIN
                                                    </h3>
                                                    <div class="card-tools">
                                                        <button type="button" class="btn btn-tool"
                                                            data-card-widget="collapse">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="card-body p-3">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <label>Target Capaian (%)<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="number"
                                                                    class="form-control form-control-sm" id="Target"
                                                                    name="Target" placeholder="Target">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Progres Capaian (%)<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="number"
                                                                    class="form-control form-control-sm" id="Capaian"
                                                                    name="Capaian" placeholder="Capaian">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Latitude<small class="text-info">
                                                                    (*desimal)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="number"
                                                                    class="form-control form-control-sm" id="LATITUDE"
                                                                    name="LATITUDE" placeholder="LATITUDE">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Longitude<small class="text-info">
                                                                    (*desimal)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="number"
                                                                    class="form-control form-control-sm" id="LONGITUDE"
                                                                    name="LONGITUDE" placeholder="LONGITUDE">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Tanggal Data<small class="text-info"> (*wajib
                                                                    diisi)</small></label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="date" class="form-control form-control-sm"
                                                                    id="TanggalData" name="TanggalData"
                                                                    :disabled="roleuser != 'admin'"
                                                                    placeholder="Tanggal Data">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <label>Keterangan</label>
                                                            <div class="input-group mb-3">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text"><i
                                                                            class="fab fa-creative-commons-share"></i></span>
                                                                </div>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    id="Keterangan" name="Keterangan"
                                                                    placeholder="Keterangan">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" v-if="this.secretencData.includes('Tambah')"
                                        data-toggle="tooltip" data-placement="left" title="Simpan data.."><i
                                            class="fas fa-plus-square"></i>
                                        Simpan</button>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(!this.secretencData.includes('Tambah'))" @click="update()"
                                        data-toggle="tooltip" data-placement="left" title="Update data.."><i
                                            class="fa fa-check-circle"></i>
                                        Update</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Batal</button>
                                </div>
                                <div class="card-footer p-3">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Nama_Kegiatan: '',

            Komponen: [],
            dataKomponen: [],
            defaultSelectedKomponen: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedKomponen: '',
            selectedKomponenlabel: '',

            SubKomponen: [],
            dataSubKomponen: [],
            defaultSelectedSubKomponen: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedSubKomponen: '',
            selectedSubKomponenlabel: '',

            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: 0,

            satker: [],
            datasatker: [],
            defaultSelectedsatker: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '0',
            },
            selectedsatker: '0',

            jenispekerjaan: [],
            datajenispekerjaan: [],
            defaultSelectedjenispekerjaan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedjenispekerjaan: 0,

            idpmis: [],
            dataidpmis: [],
            defaultSelectedidpmis: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedidpmis: 0,

            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlokasi: 0,
            paramselectedlokasi: [],
            arraynamalokasi: [],

            register: [],
            dataregister: [],
            defaultSelectedregister: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedregister: '',

            Penyedia: '',
            Mulai: '',
            Selesai: '',
            Kontrak: 0,
            Nilai: 0,
            Adendum: '',
            OWPLokal: '',
            OWP: '',
            OWPEmon: '',
            AWP: [],
            AWPEmon: [],
            DIPA: [],
            DIPAEmon: [],
            REALISASI: [],
            Target: 0,
            Capaian: 0,
            Realisasi: 0,
            Realisasi2: 0,
            TanggalData: new Date(),
            Keterangan: '',
            tahapanpekerjaan: [],
            filenya_tahapan: '',
            LATITUDE: '',
            LONGITUDE: '',
            validasi: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
            paramselectedregister: [],
            arraynamaregister: [],
            bankreview: [],
            databankreview: [],
            defaultSelectedbankreview: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedbankreview: '',

        }
    },
    methods: {
        ajukanperubahan() {
            $('#costumModalperubahan').modal('show');
        },
        async simpanajuan() {
            var kolomAWP = '';
            var nilaiAWP = '';
            for (let i = 0; i < this.AWP.length; i++) {
                if (i == 0) {
                    kolomAWP = kolomAWP + this.AWP[i].Tahun;
                    nilaiAWP = nilaiAWP + document.getElementById('AWPLokal' + this.AWP[i].Tahun).value;
                }
                else {
                    kolomAWP = kolomAWP + ',' + this.AWP[i].Tahun;
                    nilaiAWP = nilaiAWP + ',' + document.getElementById('AWPLokal' + this.AWP[i].Tahun).value;
                }
            }
            //alert(kolomAWP);
            //alert(nilaiAWP);
            //alert(JSON.stringify(this.DIPA));
            var kolomDIPA = '';
            var nilaiDIPA = '';
            for (let i = 0; i < this.DIPA.length; i++) {
                if (i == 0) {
                    kolomDIPA = kolomDIPA + this.DIPA[i].Tahun;
                    nilaiDIPA = nilaiDIPA + document.getElementById('DIPALokal' + this.AWP[i].Tahun).value;
                }
                else {
                    kolomDIPA = kolomDIPA + ',' + this.DIPA[i].Tahun;
                    nilaiDIPA = nilaiDIPA + ',' + document.getElementById('DIPALokal' + this.AWP[i].Tahun).value;
                }
            }

            var tempidnyasimpan = this.secretencData.split("_");
            var idnyasimpan = tempidnyasimpan[0];
            //alert(this.secretencData);
            //return;
            var fd = new FormData();
            fd.append("OWP", this.OWPLokal);
            fd.append("kolomAWP", kolomAWP);
            fd.append("nilaiAWP", nilaiAWP);
            fd.append("kolomDIPA", kolomDIPA);
            fd.append("nilaiDIPA", nilaiDIPA);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", idnyasimpan);
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationajuanmonev-AjukanPerubahan", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah diajukan..', 'success').then(function () {
                            window.location.replace("/Monev/" + kode);
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
        onlokasiChangeSelect(events) {
            this.paramselectedlokasi = [];
            for (let i = 0; i < events.length; i++) {
                try {
                    this.paramselectedlokasi.push((events[i].tag));
                } catch (error) {

                }
            }

            //alert(JSON.stringify(this.paramselectedlokasi));
        },
        onlokasiChangeDeselect(events) {
            //alert(JSON.stringify(events));
            var temp = [];
            temp.push(events);
            //alert(JSON.stringify(temp));
            var yghilang = '';
            for (let i = 0; i < temp.length; i++) {
                try {
                    yghilang = (temp[i].tag);
                } catch (error) {

                }
            }

            var temparray = [];
            for (let i = 0; i < this.paramselectedlokasi.length; i++) {
                //alert(this.paramselectedlokasi[i])
                //alert('Hilang '+(yghilang))
                if (this.paramselectedlokasi[i] !== yghilang) {
                    try {
                        temparray.push(this.paramselectedlokasi[i]);
                    } catch (error) {

                    }
                }
            }
            this.paramselectedlokasi = temparray;
            //alert(JSON.stringify(this.paramselectedlokasi));
        },
        onregisterChangeSelect(events) {
            this.paramselectedregister = [];
            for (let i = 0; i < events.length; i++) {
                try {
                    this.paramselectedregister.push((events[i].tag));
                } catch (error) {

                }
            }

            //alert(JSON.stringify(this.paramselectedregister));
        },
        onregisterChangeDeselect(events) {
            //alert(JSON.stringify(events));
            var temp = [];
            temp.push(events);
            //alert(JSON.stringify(temp));
            var yghilang = '';
            for (let i = 0; i < temp.length; i++) {
                try {
                    yghilang = (temp[i].tag);
                } catch (error) {

                }
            }

            var temparray = [];
            for (let i = 0; i < this.paramselectedregister.length; i++) {
                //alert(this.paramselectedregister[i])
                //alert('Hilang '+(yghilang))
                if (this.paramselectedregister[i] !== yghilang) {
                    try {
                        temparray.push(this.paramselectedregister[i]);
                    } catch (error) {

                    }
                }
            }
            this.paramselectedregister = temparray;
            //alert(JSON.stringify(this.paramselectedregister));
        },
        rubahowp(kode) {
            this.OWP = document.getElementById(kode).value;
        },
        rubahsinkronisasi(awal, akhir) {
            document.getElementById(akhir).value = document.getElementById(awal).value;
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(idnya);
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", "filenya_tahapan");
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", "filenya_tahapan");
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    document.getElementById(idnya).value == '';
                    this.filenya_regulasi = '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },

        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            mainAPI5.get("parastapainnovation_userproject-GetPIU?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            if (this.roleuser == 'user') {
                var idadi = this.levelinstansi;
            }
            else {
                var idadi = '';
            }

            mainAPI5.get("parastapainnovation_userproject-GetSatker?random=" + random + "&project_id=" + this.project_id + "&id_user=" + idadi).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasatker = [];
                        this.satker = [];
                        this.datasatker = Response.data.content.data;
                        this.datasatker.forEach((item) => {
                            this.satker.push({
                                label: item.namasatker,
                                code: this.datasatker.indexOf(item) + 1,
                                tag: item.kodesatker,
                            });
                        });
                        this.satker.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '0',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            mainAPI5.get("parastapainnovation_jenispekerjaan-GetJenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan = [];
                        this.jenispekerjaan = [];
                        this.datajenispekerjaan = Response.data.content.data;
                        this.datajenispekerjaan.forEach((item) => {
                            this.jenispekerjaan.push({
                                label: item.nama,
                                code: this.datajenispekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.jenispekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovation_bankreview-Data?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.databankreview = [];
                        this.bankreview = [];
                        this.databankreview = Response.data.content.data;
                        this.databankreview.forEach((item) => {
                            this.bankreview.push({
                                label: item.nama,
                                code: this.databankreview.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.bankreview.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            mainAPI5.get("parastapainnovation_tahapanpekerjaan-GetTahapanPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataStatus_pekerjaan = [];
                        this.Status_pekerjaan = [];
                        this.dataStatus_pekerjaan = Response.data.content.data;
                        this.dataStatus_pekerjaan.forEach((item) => {
                            this.Status_pekerjaan.push({
                                label: item.nama,
                                code: this.dataStatus_pekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.Status_pekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            mainAPI5.get("parastapainnovation_lokasi-KotaProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            mainAPI5.get("parastapainnovation_koderegister-GetKodeRegister?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataregister = [];
                        this.register = [];
                        this.dataregister = Response.data.content.data;
                        this.dataregister.forEach((item) => {
                            this.register.push({
                                label: item.kode_register_lengkap,
                                code: this.dataregister.indexOf(item) + 1,
                                tag: item.kode_register,
                            });
                        });
                        this.register.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            const mainAPI6 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            mainAPI6.get("parastapainnovationKomponen-GetProyekKomponen?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataKomponen = [];
                        this.Komponen = [];
                        this.dataKomponen = Response.data.content.data;
                        this.dataKomponen.forEach((item) => {
                            this.Komponen.push({
                                label: item.nama,
                                code: this.dataKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.Komponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            mainAPI6.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedKomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.dataSubKomponen = Response.data.content.data;
                        this.dataSubKomponen.forEach((item) => {
                            this.SubKomponen.push({
                                label: item.nama,
                                code: this.dataSubKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });

                    }
                    else {
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            //alert(this.secretencData);
            setTimeout(() => {
                this.AmbilDataSingel();
            }, 1000); // 2000 milliseconds = 2 seconds

        },
        onbankreviewChange(a) {
            try {
                this.selectedbankreview = this.bankreview[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onKomponenChange(a) {
            try {
                this.selectedKomponen = this.Komponen[a].tag;
                this.selectedKomponenlabel = this.Komponen[a].label;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedKomponen);
            this.getsubkomponen();
        },
        onSubKomponenChange(a) {
            try {
                this.selectedSubKomponen = this.SubKomponen[a].tag;
                this.selectedSubKomponenlabel = this.SubKomponen[a].label;
            }
            catch (err) {
                return;
            }
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
            this.defaultSelectedsatker = {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            };
            this.selectedsatker = '0';
            this.pilihSatker();
        },
        onsatkerChange(a) {
            try {
                this.selectedsatker = this.satker[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onjenispekerjaanChange(a) {
            try {
                this.selectedjenispekerjaan = this.jenispekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
            this.AmbilTahapanPekerjaan();

            //alert(this.selectedjenispekerjaan);
        },
        onregisterChange(a) {
            try {
                this.selectedregister = this.register[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onidpmisChange(a) {
            try {
                this.selectedidpmis = this.idpmis[a].tag;
            }
            catch (err) {
                return;
            }
        },
        async sinkorinasi() {
            //return false;
            if ((this.selectedid_user == '') || (this.selectedid_user == '0')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih PIU',
                });
                $('#costumModalsinkronisasi').modal('hide');
                //document.getElementById('customCheckboxSinkronisasi').checked = false;
                return false;
            }
            if ((this.selectedidpmis == '') || (this.selectedidpmis == '0')) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Pilih Kegiatan PMIS',
                });
                $('#costumModalsinkronisasi').modal('hide');
                //document.getElementById('customCheckboxSinkronisasi').checked = false;
                return false;
            }

            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationmonev-SinkronisasiPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user + "&id_kegiatan=" + this.selectedidpmis).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        $('#costumModalsinkronisasi').modal('show');
                        this.OWPEmon = this.G_numFormat(Response.data.content.data[0].anggaran_owp);
                        this.AWPEmon = Response.data.content.data[0].awp;
                        this.DIPAEmon = Response.data.content.data[0].dipa;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            //alert(this.selectedidpmis);
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            //alert(this.secretencData);
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Monev/" + kode);
        },
        async AmbilTahapanPekerjaan() {
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            this.tahapanpekerjaan = [];
            await mainAPIDataSingelcari.get("parastapainnovation_tahapanpekerjaan-GetAll?random=" + random + "&project_id=" + this.project_id + "&jenis_pekerjaan=" + this.selectedjenispekerjaan + "&id_kegiatan=" + this.secretencData).then(
                Responsecari => {
                    this.tahapanpekerjaan = Responsecari.data.content.data;
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        async pilihKegiatanPMIS() {
            this.halamanloading = true;
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingelcari.get("parastapainnovation_idkegiatanpmis-GetIdKegiatanPMIS?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user).then(
                Responsecari => {
                    this.dataidpmis = [];
                    this.idpmis = [];
                    this.dataidpmis = Responsecari.data.content.data;
                    this.dataidpmis.forEach((item) => {
                        this.idpmis.push({
                            label: item.nama_kegiatan,
                            code: this.dataidpmis.indexOf(item) + 1,
                            tag: item.id_kegiatan,
                        });
                    });
                    this.idpmis.unshift({
                        label: 'Pilih Salah Satu',
                        code: 0,
                        tag: '',
                    });
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


        },
        async pilihSatker() {
            this.halamanloading = true;
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            mainAPIDataSingelcari.get("parastapainnovation_userproject-GetSatker?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasatker = [];
                        this.satker = [];
                        this.datasatker = Response.data.content.data;
                        this.datasatker.forEach((item) => {
                            this.satker.push({
                                label: item.namasatker,
                                code: this.datasatker.indexOf(item) + 1,
                                tag: item.kodesatker,
                            });
                        });
                        this.satker.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


        },
        AmbilDataSingel() {
            //alert(this.secretencData);
            this.halamanloading = true;


            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];
            //alert(terpilih);

            var random = Math.random();
            mainAPIDataSingel.get("parastapainnovationmonev-GetByIDMonev?id=" + terpilih + "&random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.Nama_Kegiatan = Response.data.content.data[0].Nama_Kegiatan;

                    var id_userpmis = Response.data.content.data[0].id_user;
                    if (id_userpmis != '') {
                        this.defaultSelectedid_user = {
                            code: Response.data.content.data[0].id_user,
                            label: Response.data.content.data[0].nama_satker,
                            tag: Response.data.content.data[0].id_user,
                        };
                        this.selectedid_user = Response.data.content.data[0].id_user;
                    }

                    //alert(this.selectedid_user);
                    if (this.selectedid_user != '') {
                        mainAPIDataSingelcari.get("parastapainnovation_userproject-GetSatker?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user).then(
                            Response => {
                                this.datapesan = Response.data.message;
                                //alert(this.datapesan);
                                if (this.datapesan == 'data diketemukan') {
                                    this.datasatker = [];
                                    this.satker = [];
                                    this.datasatker = Response.data.content.data;
                                    this.datasatker.forEach((item) => {
                                        this.satker.push({
                                            label: item.namasatker,
                                            code: this.datasatker.indexOf(item) + 1,
                                            tag: item.kodesatker,
                                        });
                                    });
                                    this.satker.unshift({
                                        label: 'Pilih Salah Satu',
                                        code: 0,
                                        tag: '0',
                                    });
                                }
                                this.halamanloading = false;
                            }
                        ).catch(error => {
                            console.log(error);
                            //this.ClearlocalStorage();
                            this.halamanloading = false;
                        });
                    }
                    var satkerpmis = Response.data.content.data[0].satker;
                    if (satkerpmis != '') {
                        this.defaultSelectedsatker = {
                            code: Response.data.content.data[0].satker,
                            label: Response.data.content.data[0].namasatker,
                            tag: Response.data.content.data[0].satker,
                        };
                        this.selectedsatker = Response.data.content.data[0].satker;
                    }
                    var tipe_work = Response.data.content.data[0].tipe_work;
                    if (tipe_work != '') {
                        this.defaultSelectedjenispekerjaan = {
                            code: Response.data.content.data[0].tipe_work,
                            label: Response.data.content.data[0].Kategori,
                            tag: Response.data.content.data[0].tipe_work,
                        };
                    }

                    this.defaultSelectedbankreview = {
                        code: Response.data.content.data[0].BankReview,
                        label: Response.data.content.data[0].namaBankReview,
                        tag: Response.data.content.data[0].BankReview,
                    };


                    this.defaultSelectedStatus_pekerjaan = {
                        code: Response.data.content.data[0].idstatuspekerjaan,
                        label: Response.data.content.data[0].Status_pekerjaan,
                        tag: Response.data.content.data[0].idstatuspekerjaan,
                    };
                    this.defaultSelectedlokasi = {
                        code: Response.data.content.data[0].Lokasi,
                        label: Response.data.content.data[0].namalokasi,
                        tag: Response.data.content.data[0].Lokasi,
                    };

                    this.selectedlokasi = Response.data.content.data[0].Lokasi;

                    if (Response.data.content.data[0].Lokasi == '') {
                        this.defaultSelectedlokasi = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.selectedlokasi = '';
                    }

                    this.selectedjenispekerjaan = Response.data.content.data[0].tipe_work;
                    this.selectedStatus_pekerjaan = Response.data.content.data[0].idstatuspekerjaan;
                    //alert(Response.data.content.data[0].id_pmis);

                    this.tahapanpekerjaan = [];
                    mainAPIDataSingelcari.get("parastapainnovation_tahapanpekerjaan-GetAll?random=" + random + "&project_id=" + this.project_id + "&jenis_pekerjaan=" + Response.data.content.data[0].tipe_work + "&id_kegiatan=" + this.secretencData).then(
                        Responsecari => {
                            this.tahapanpekerjaan = Responsecari.data.content.data;
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });


                    //this.Penyedia = Response.data.content.data[0].KONTRAKTOR;
                    var registernya = Response.data.content.data[0].register;
                    this.arraynamaregister = [];
                    try {
                        var myArray = registernya.split(",");
                    } catch (error) {
                        var myArray = [];
                    }

                    //alert(myArray.length);

                    mainAPIDataSingelcari.get("parastapainnovation_koderegister-GetKodeRegister?random=" + random + "&project_id=" + this.project_id).then(
                        Response => {
                            this.datapesan = Response.data.message;
                            //alert(this.datapesan);
                            if (this.datapesan == 'data diketemukan') {
                                this.dataregister = [];
                                this.register = [];
                                this.dataregister = Response.data.content.data;
                                this.dataregister.forEach((item) => {
                                    for (let i = 0; i < myArray.length; i++) {
                                        if (item.kode_register == myArray[i]) {
                                            //this.arraynamaregister.push(item.kode_register_lengkap);
                                            this.arraynamaregister.push({
                                                label: item.kode_register_lengkap,
                                                code: this.dataregister.indexOf(item) + 1,
                                                tag: item.kode_register,
                                            });

                                            this.paramselectedregister.push(item.kode_register);
                                        }
                                    }
                                    if (item.kode_register == registernya) {
                                        this.defaultSelectedregister = {
                                            code: this.dataregister.indexOf(item) + 1,
                                            label: item.kode_register_lengkap,
                                            tag: item.kode_register,
                                        };
                                        this.selectedregister = item.kode_register;
                                    }
                                    this.register.push({
                                        label: item.kode_register_lengkap,
                                        code: this.dataregister.indexOf(item) + 1,
                                        tag: item.kode_register,
                                    });
                                });
                            }
                            this.halamanloading = false;
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });

                    this.selectedbankreview = Response.data.content.data[0].BankReview;
                    document.getElementById('Penyedia').value = Response.data.content.data[0].KONTRAKTOR;
                    document.getElementById('Mulai').value = Response.data.content.data[0].MULAI;
                    document.getElementById('Selesai').value = Response.data.content.data[0].SELESAI;
                    document.getElementById('Kontrak').value = Response.data.content.data[0].NOKONTRAK;
                    document.getElementById('Nilai').value = this.G_numFormat(Response.data.content.data[0].NILAIKONTRAK);
                    //this.Nilai = this.G_numFormat(Response.data.content.data[0].NILAIKONTRAK);
                    document.getElementById('Adendum').value = Response.data.content.data[0].ADENDUM;
                    //this.Adendum = Response.data.content.data[0].ADENDUM;
                    this.OWPLokal = this.G_numFormat(Response.data.content.data[0].OWP);
                    this.OWP = this.G_numFormat(Response.data.content.data[0].OWP);
                    this.AWP = Response.data.content.data[0].AWP;
                    this.DIPA = Response.data.content.data[0].DIPA;
                    this.REALISASI = Response.data.content.data[0].REALISASI;
                    //this.datalist.Ouput = Response.data.content.data[0].datalist.Ouput;
                    this.Capaian = Response.data.content.data[0].PROGRES;
                    document.getElementById('Target').value = Response.data.content.data[0].TARGET;
                    document.getElementById('Capaian').value = Response.data.content.data[0].PROGRES;
                    //this.Capaian = Response.data.content.data[0].PROGRES;
                    document.getElementById('Realisasi').value = this.G_numFormat(Response.data.content.data[0].REALISASI_KUMULATIF);
                    document.getElementById('Realisasi2').value = this.G_numFormat(Response.data.content.data[0].REALISASI_KUMULATIF2);
                    //this.Realisasi = this.G_numFormat(Response.data.content.data[0].REALISASI_KUMULATIF);
                    document.getElementById('TanggalData').value = Response.data.content.data[0].TANGGALDATA;
                    document.getElementById('Keterangan').value = Response.data.content.data[0].KETERANGAN;
                    document.getElementById('LATITUDE').value = Response.data.content.data[0].LATITUDE;
                    document.getElementById('LONGITUDE').value = Response.data.content.data[0].LONGITUDE;

                    var Komponentemp = Response.data.content.data[0].Komponen;
                    var SubKomponentemp = Response.data.content.data[0].SubKomponen;

                    //alert(Komponentemp);
                    for (let i = 0; i < this.Komponen.length; i++) {
                        if (Komponentemp == this.Komponen[i].label) {
                            this.defaultSelectedKomponen = {
                                code: this.Komponen[i].code,
                                label: this.Komponen[i].label,
                                tag: this.Komponen[i].tag,
                            };
                            this.selectedKomponenlabel = Komponentemp;
                        }
                    }

                    for (let i = 0; i < this.SubKomponen.length; i++) {
                        if (SubKomponentemp == this.SubKomponen[i].label) {
                            this.defaultSelectedSubKomponen = {
                                code: this.SubKomponen[i].code,
                                label: this.SubKomponen[i].label,
                                tag: this.SubKomponen[i].tag,
                            };
                            this.selectedSubKomponenlabel = SubKomponentemp;
                        }
                    }

                    var lokasinya = Response.data.content.data[0].Lokasi_Detail;
                    this.arraynamalokasi = [];
                    try {
                        var myArraylok = lokasinya.split(",");
                    } catch (error) {
                        var myArraylok = [];
                    }

                    const mainAPIDataSingelcarilokasi = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                        },
                    });


                    mainAPIDataSingelcarilokasi.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                        Response => {
                            this.datapesan = Response.data.message;
                            //alert(this.datapesan);
                            if (this.datapesan == 'data diketemukan') {
                                this.datalokasi = [];
                                this.lokasi = [];
                                this.datalokasi = Response.data.content.data;
                                this.datalokasi.forEach((item) => {
                                    for (let i = 0; i < myArraylok.length; i++) {
                                        if (item.id == myArraylok[i]) {
                                            //this.arraynamalokasi.push(item.kode_lokasi_lengkap);
                                            this.arraynamalokasi.push({
                                                label: item.nama,
                                                code: this.datalokasi.indexOf(item) + 1,
                                                tag: item.id,
                                            });

                                            this.paramselectedlokasi.push(item.id);
                                        }
                                    }
                                    if (item.id == lokasinya) {
                                        this.defaultSelectedlokasi = {
                                            code: this.datalokasi.indexOf(item) + 1,
                                            label: item.nama,
                                            tag: item.id,
                                        };
                                        this.selectedlokasi = item.id;
                                    }
                                    this.lokasi.push({
                                        label: item.nama,
                                        code: this.datalokasi.indexOf(item) + 1,
                                        tag: item.id,
                                    });
                                });
                            }
                            this.halamanloading = false;
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });

                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        cekvalidasitahapan(kode) {
            //alert(kode);
            return;
            var arraycek = [];
            for (let x = 0; x < this.tahapanpekerjaan.length; x++) {
                for (let i = 0; i < this.tahapanpekerjaan[x].tahapan.length; i++) {
                    //alert(x-1);
                    arraycek.push(this.tahapanpekerjaan[x].tahapan[i].id);
                }
            }
            var index = arraycek.indexOf(kode);
            //alert(index);
            if (index > 0) {
                if (document.getElementById('Status_pekerjaan_' + arraycek[index - 1]).checked == false) {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Silahkan pilih terlebih dahulu tahapan sebelumnya..',
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById('Status_pekerjaan_' + kode).checked = false;
                }
            }
        },
        cektanggal(kode) {
            var tanggal = new Date(document.getElementById('Mulai' + kode).value);
            var sdtanggal = new Date(document.getElementById('Selesai' + kode).value);
            if (tanggal > sdtanggal) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Tanggal Mulai Tidak Boleh Lebih Besar..',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
        },
        validasidata() {
            if ((this.selectedid_user == '') || (this.selectedid_user === null) || (this.selectedid_user === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih PIU..',
                });
                return false;
            }
            if ((this.selectedsatker == '') || (this.selectedsatker === null) || (this.selectedsatker === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Satker..',
                });
                return false;
            }
            if ((this.paramselectedregister == '') || (this.paramselectedregister == null) || (this.paramselectedregister == undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Kode Register..',
                });
                return false;
            }
            if (document.getElementById('Nama_Kegiatan').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('Nama_Kegiatan').focus();
                return false;
            }
            if ((this.selectedlokasi == '') || (this.selectedlokasi === null) || (this.selectedlokasi === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Lokasi Kota..',
                });
                return false;
            }

            if (this.AWP == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan AWP..',
                });
                return false;
            }
            if (this.DIPA == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan DIPA..',
                });
                return false;
            }
            if (this.REALISASI == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan REALISASI..',
                });
                return false;
            }
            if ((this.selectedKomponenlabel == '') || (this.selectedKomponenlabel === null) || (this.selectedKomponenlabel === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Komponen / Output..',
                });
                return false;
            }

            if ((this.selectedSubKomponenlabel == '') || (this.selectedSubKomponenlabel === null) || (this.selectedSubKomponenlabel === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Sub Komponen..',
                });
                return false;
            }

            if ((this.selectedjenispekerjaan == '') || (this.selectedjenispekerjaan === null) || (this.selectedjenispekerjaan === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Jenis Pekerjaan..',
                });
                return false;
            }

            if (this.tahapanpekerjaan == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Tahapan Pekerjaan..',
                });
                return false;
            }

            if (document.getElementById('TanggalData').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Tanggal Data..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            var kolomAWP = '';
            var nilaiAWP = '';
            for (let i = 0; i < this.AWP.length; i++) {
                if (i == 0) {
                    kolomAWP = kolomAWP + this.AWP[i].Tahun;
                    nilaiAWP = nilaiAWP + document.getElementById('AWP' + this.AWP[i].Tahun).value;
                }
                else {
                    kolomAWP = kolomAWP + ',' + this.AWP[i].Tahun;
                    nilaiAWP = nilaiAWP + ',' + document.getElementById('AWP' + this.AWP[i].Tahun).value;
                }
            }
            //alert(kolomAWP);
            //alert(nilaiAWP);
            //alert(JSON.stringify(this.DIPA));
            var kolomDIPA = '';
            var nilaiDIPA = '';
            for (let i = 0; i < this.DIPA.length; i++) {
                if (i == 0) {
                    kolomDIPA = kolomDIPA + this.DIPA[i].Tahun;
                    nilaiDIPA = nilaiDIPA + document.getElementById('DIPA' + this.AWP[i].Tahun).value;
                }
                else {
                    kolomDIPA = kolomDIPA + ',' + this.DIPA[i].Tahun;
                    nilaiDIPA = nilaiDIPA + ',' + document.getElementById('DIPA' + this.AWP[i].Tahun).value;
                }
            }

            var kolomREALISASI = '';
            var nilaiREALISASI = '';
            for (let i = 0; i < this.REALISASI.length; i++) {
                if (i == 0) {
                    kolomREALISASI = kolomREALISASI + this.REALISASI[i].Tahun;
                    nilaiREALISASI = nilaiREALISASI + document.getElementById('REALISASI' + this.AWP[i].Tahun).value;
                }
                else {
                    kolomREALISASI = kolomREALISASI + ',' + this.REALISASI[i].Tahun;
                    nilaiREALISASI = nilaiREALISASI + ',' + document.getElementById('REALISASI' + this.AWP[i].Tahun).value;
                }
            }


            var idtahapan = '';
            var pilihtahapan = '';
            var mulaitahapan = '';
            var selesaitahapan = '';
            var filenya_tahapan = '';
            for (let z = 0; z < this.tahapanpekerjaan.length; z++) {
                for (let i = 0; i < this.tahapanpekerjaan[z].tahapan.length; i++) {
                    if ((i == 0) && (z == 0)) {
                        idtahapan = idtahapan + this.tahapanpekerjaan[z].tahapan[i].id;
                        pilihtahapan = pilihtahapan + document.getElementById('Status_pekerjaan_' + this.tahapanpekerjaan[z].tahapan[i].id).checked;
                        mulaitahapan = mulaitahapan + document.getElementById('Mulai' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        selesaitahapan = selesaitahapan + document.getElementById('Selesai' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        filenya_tahapan = filenya_tahapan + document.getElementById('filenya_tahapan' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                    }
                    else {
                        idtahapan = idtahapan + ',' + this.tahapanpekerjaan[z].tahapan[i].id;
                        pilihtahapan = pilihtahapan + ',' + document.getElementById('Status_pekerjaan_' + this.tahapanpekerjaan[z].tahapan[i].id).checked;
                        mulaitahapan = mulaitahapan + ',' + document.getElementById('Mulai' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        selesaitahapan = selesaitahapan + ',' + document.getElementById('Selesai' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        filenya_tahapan = filenya_tahapan + ',' + document.getElementById('filenya_tahapan' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                    }
                }
            }
            //alert(document.getElementById('Penyedia').value);
            //console.log(this.Penyedia);
            //console.log(this.Nilai);
            //console.log(document.getElementById('Mulai').value);
            //console.log(document.getElementById('Selesai').value);
            //console.log(this.Kontrak);
            //return false;

            var fd = new FormData();
            fd.append("id_user", this.selectedid_user);
            fd.append("satker", this.selectedsatker);
            fd.append("id_pmis", this.selectedidpmis);
            fd.append("register", this.paramselectedregister);
            fd.append("Nama_Kegiatan", this.Nama_Kegiatan);
            fd.append("Lokasi", this.selectedlokasi);
            fd.append("Lokasi_Detail", this.paramselectedlokasi);
            fd.append("OWP", this.OWP);
            fd.append("kolomAWP", kolomAWP);
            fd.append("nilaiAWP", nilaiAWP);
            fd.append("kolomDIPA", kolomDIPA);
            fd.append("nilaiDIPA", nilaiDIPA);
            fd.append("kolomREALISASI", kolomREALISASI);
            fd.append("nilaiREALISASI", nilaiREALISASI);
            fd.append("Komponen", this.selectedKomponenlabel);
            fd.append("SubKomponen", this.selectedSubKomponenlabel);
            fd.append("KodeKategori", this.selectedjenispekerjaan);
            fd.append("tipe_work", this.selectedjenispekerjaan);
            fd.append("BankReview", this.selectedbankreview);
            fd.append("idtahapan", idtahapan);
            fd.append("pilihtahapan", pilihtahapan);
            fd.append("mulaitahapan", mulaitahapan);
            fd.append("selesaitahapan", selesaitahapan);
            fd.append("filenya_tahapan", filenya_tahapan);
            fd.append("KONTRAKTOR", document.getElementById('Penyedia').value);
            fd.append("NILAIKONTRAK", document.getElementById('Nilai').value);
            fd.append("MULAI", document.getElementById('Mulai').value);
            fd.append("SELESAI", document.getElementById('Selesai').value);
            fd.append("NOKONTRAK", document.getElementById('Kontrak').value);
            fd.append("ADENDUM", document.getElementById('Adendum').value);
            fd.append("TARGET", document.getElementById('Target').value);
            fd.append("PROGRES", document.getElementById('Capaian').value);
            fd.append("NILAI_KEUANGAN", document.getElementById('Realisasi').value);
            fd.append("NILAI_KEUANGAN2", document.getElementById('Realisasi2').value);
            fd.append("datadate", document.getElementById('TanggalData').value);
            fd.append("latitude", document.getElementById('LATITUDE').value);
            fd.append("longitude", document.getElementById('LONGITUDE').value);
            fd.append("Remark", document.getElementById('Keterangan').value);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            mainAPI.post("parastapainnovationaddmonev-TambahDataManualMonev", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah ditambah..', 'success').then(function () {
                            window.location.replace("/Monev/" + kode);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            var kolomAWP = '';
            var nilaiAWP = '';
            for (let i = 0; i < this.AWP.length; i++) {
                if (i == 0) {
                    kolomAWP = kolomAWP + this.AWP[i].Tahun;
                    nilaiAWP = nilaiAWP + document.getElementById('AWP' + this.AWP[i].Tahun).value;
                }
                else {
                    kolomAWP = kolomAWP + ',' + this.AWP[i].Tahun;
                    nilaiAWP = nilaiAWP + ',' + document.getElementById('AWP' + this.AWP[i].Tahun).value;
                }
            }
            //alert(kolomAWP);
            //alert(nilaiAWP);
            //alert(JSON.stringify(this.DIPA));
            var kolomDIPA = '';
            var nilaiDIPA = '';
            for (let i = 0; i < this.DIPA.length; i++) {
                if (i == 0) {
                    kolomDIPA = kolomDIPA + this.DIPA[i].Tahun;
                    nilaiDIPA = nilaiDIPA + document.getElementById('DIPA' + this.AWP[i].Tahun).value;
                }
                else {
                    kolomDIPA = kolomDIPA + ',' + this.DIPA[i].Tahun;
                    nilaiDIPA = nilaiDIPA + ',' + document.getElementById('DIPA' + this.AWP[i].Tahun).value;
                }
            }


            var kolomREALISASI = '';
            var nilaiREALISASI = '';
            for (let i = 0; i < this.REALISASI.length; i++) {
                if (i == 0) {
                    kolomREALISASI = kolomREALISASI + this.REALISASI[i].Tahun;
                    nilaiREALISASI = nilaiREALISASI + document.getElementById('REALISASI' + this.AWP[i].Tahun).value;
                }
                else {
                    kolomREALISASI = kolomREALISASI + ',' + this.REALISASI[i].Tahun;
                    nilaiREALISASI = nilaiREALISASI + ',' + document.getElementById('REALISASI' + this.AWP[i].Tahun).value;
                }
            }




            var idtahapan = '';
            var pilihtahapan = '';
            var mulaitahapan = '';
            var selesaitahapan = '';
            var filenya_tahapan = '';
            for (let z = 0; z < this.tahapanpekerjaan.length; z++) {
                for (let i = 0; i < this.tahapanpekerjaan[z].tahapan.length; i++) {
                    if ((i == 0) && (z == 0)) {
                        idtahapan = idtahapan + this.tahapanpekerjaan[z].tahapan[i].id;
                        pilihtahapan = pilihtahapan + document.getElementById('Status_pekerjaan_' + this.tahapanpekerjaan[z].tahapan[i].id).checked;
                        mulaitahapan = mulaitahapan + document.getElementById('Mulai' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        selesaitahapan = selesaitahapan + document.getElementById('Selesai' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        filenya_tahapan = filenya_tahapan + document.getElementById('filenya_tahapan' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                    }
                    else {
                        idtahapan = idtahapan + ',' + this.tahapanpekerjaan[z].tahapan[i].id;
                        pilihtahapan = pilihtahapan + ',' + document.getElementById('Status_pekerjaan_' + this.tahapanpekerjaan[z].tahapan[i].id).checked;
                        mulaitahapan = mulaitahapan + ',' + document.getElementById('Mulai' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        selesaitahapan = selesaitahapan + ',' + document.getElementById('Selesai' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        filenya_tahapan = filenya_tahapan + ',' + document.getElementById('filenya_tahapan' + this.tahapanpekerjaan[z].tahapan[i].id).value;
                    }
                }
            }
            //alert(document.getElementById('Penyedia').value);
            //console.log(this.Penyedia);
            //console.log(this.Nilai);
            //console.log(document.getElementById('Mulai').value);
            //console.log(document.getElementById('Selesai').value);
            //console.log(this.Kontrak);
            //return false;
            //alert(document.getElementById('Selesai').value);
            var tempidnyasimpan = this.secretencData.split("_");
            var idnyasimpan = tempidnyasimpan[0];
            //alert(this.secretencData);
            //return;
            var fd = new FormData();
            fd.append("id_user", this.selectedid_user);
            fd.append("satker", this.selectedsatker);
            fd.append("id_pmis", this.selectedidpmis);
            fd.append("register", this.paramselectedregister);
            fd.append("Nama_Kegiatan", this.Nama_Kegiatan);
            fd.append("Lokasi", this.selectedlokasi);
            fd.append("Lokasi_Detail", this.paramselectedlokasi);
            fd.append("OWP", this.OWP);
            fd.append("kolomAWP", kolomAWP);
            fd.append("nilaiAWP", nilaiAWP);
            fd.append("kolomDIPA", kolomDIPA);
            fd.append("nilaiDIPA", nilaiDIPA);
            fd.append("kolomREALISASI", kolomREALISASI);
            fd.append("nilaiREALISASI", nilaiREALISASI);
            fd.append("Komponen", this.selectedKomponenlabel);
            fd.append("SubKomponen", this.selectedSubKomponenlabel);
            fd.append("KodeKategori", this.selectedjenispekerjaan);
            fd.append("tipe_work", this.selectedjenispekerjaan);
            fd.append("BankReview", this.selectedbankreview);
            fd.append("idtahapan", idtahapan);
            fd.append("pilihtahapan", pilihtahapan);
            fd.append("mulaitahapan", mulaitahapan);
            fd.append("selesaitahapan", selesaitahapan);
            fd.append("filenya_tahapan", filenya_tahapan);
            fd.append("KONTRAKTOR", document.getElementById('Penyedia').value);
            fd.append("NILAIKONTRAK", document.getElementById('Nilai').value);
            fd.append("MULAI", document.getElementById('Mulai').value);
            fd.append("SELESAI", document.getElementById('Selesai').value);
            fd.append("NOKONTRAK", document.getElementById('Kontrak').value);
            fd.append("ADENDUM", document.getElementById('Adendum').value);
            fd.append("TARGET", document.getElementById('Target').value);
            fd.append("PROGRES", document.getElementById('Capaian').value);
            fd.append("NILAI_KEUANGAN", document.getElementById('Realisasi').value);
            fd.append("NILAI_KEUANGAN2", document.getElementById('Realisasi2').value);
            fd.append("datadate", document.getElementById('TanggalData').value);
            fd.append("latitude", document.getElementById('LATITUDE').value);
            fd.append("longitude", document.getElementById('LONGITUDE').value);
            fd.append("Remark", document.getElementById('Keterangan').value);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("log", "0");
            fd.append("id", idnyasimpan);
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationmonev-UpdateManualMOnev", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/Monev/" + kode);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;

        },
        async getsubkomponen() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedKomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.dataSubKomponen = Response.data.content.data;
                        this.dataSubKomponen.forEach((item) => {
                            this.SubKomponen.push({
                                label: item.nama,
                                code: this.dataSubKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.ambildatareff();
        //alert(this.secretencData);
    }
}
</script>
<style></style>